$(document).ready(function () {

  /*
  const countDownDate = new Date("Oct 15, 2023 00:00:00").getTime();

  const countdownInterval = setInterval(function () {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
          clearInterval(countdownInterval);
          document.getElementById("countdown").innerHTML = "STONE CRAB SEASON IS HERE";
      } else {
          // Display the result and countdown text
          document.getElementById("countdown-text").style.display = "inline-block";
          document.querySelectorAll("#countdown div").forEach(function (el) {
              el.style.display = "inline-block";
          });

          document.getElementById("days").innerHTML = `${days} <span>days</span>`;
          document.getElementById("hours").innerHTML = `${hours} <span>hrs</span>`;
          document.getElementById("minutes").innerHTML = `${minutes} <span>min</span>`;
          document.getElementById("seconds").innerHTML = `${seconds} <span>sec</span>`;
      }
  }, 1000);

  */
});

document.addEventListener("DOMContentLoaded", function () {

  const el = document.querySelector('.announcement-bar__message > div > p:nth-child(1) > a');
  if (el) {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      window.alia = window.alia || [];
      window.alia.push({
        type: "open",
        campaignID: 2973,
        ignoreTargeting: true
      });
    });
  }

})();